export const SMVM_GET_ASSESSOR_GUIDE_REQUEST =
  "SMVM_GET_ASSESSOR_GUIDE_REQUEST";
export const SMVM_GET_ASSESSOR_GUIDE_SUCCESS =
  "SMVM_GET_ASSESSOR_GUIDE_SUCCESS";
export const SMVM_GET_ASSESSOR_GUIDE_FAIL = "SMVM_GET_ASSESSOR_GUIDE_FAIL";
export const SMVM_GET_ASSESSOR_GUIDE_RESET = "SMVM_GET_ASSESSOR_GUIDE_RESET";

export const SMVM_GET_ASSESSEE_GUIDE_REQUEST =
  "SMVM_GET_ASSESSEE_GUIDE_REQUEST";
export const SMVM_GET_ASSESSEE_GUIDE_SUCCESS =
  "SMVM_GET_ASSESSEE_GUIDE_SUCCESS";
export const SMVM_GET_ASSESSEE_GUIDE_FAIL = "SMVM_GET_ASSESSEE_GUIDE_FAIL";
export const SMVM_GET_ASSESSEE_GUIDE_RESET = "SMVM_GET_ASSESSEE_GUIDE_RESET";

export const SMVM_GET_ASPECT_GUIDE_REQUEST = "SMVM_GET_ASPECT_GUIDE_REQUEST";
export const SMVM_GET_ASPECT_GUIDE_SUCCESS = "SMVM_GET_ASPECT_GUIDE_SUCCESS";
export const SMVM_GET_ASPECT_GUIDE_FAIL = "SMVM_GET_ASPECT_GUIDE_FAIL";
export const SMVM_GET_ASPECT_GUIDE_RESET = "SMVM_GET_ASPECT_GUIDE_RESET";
